import { Component } from '@angular/core';


@Component({
	selector: 'finance-cost-tab-2-part',
	standalone: true,
	templateUrl: './finance-cost-tab-2.part.html',
	styleUrls: [`./finance-cost-tab-2.part.scss`],
})
export class FinanceCostTab2Part {
}
